import { render, staticRenderFns } from "./PropertyListOf.vue?vue&type=template&id=4cc1e0ce&lang=pug&"
import script from "./PropertyListOf.vue?vue&type=script&lang=js&"
export * from "./PropertyListOf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports